/* istanbul ignore file */
/**
 * For options pass object with:
 *   site_key: pass site key
 *   alignHorizontal: default is 'left', or pass 'right'
 *   alignVertical: default is 'bottom', or pass 'middle'
 *
 * @param {*} options
 */

const formattedBotnet = function (options) {
  options = options || {}

  if (!options?.site_key) {
    console.warn('No site_key provided for equalweb.')
    return
  }

  // eslint-disable-next-line no-console
  console.info(
    '%c Loading EqualWeb',
    'background: #036eb5; color: #fff; padding: 3px 6px;'
  )

  const defaultOptions = {
    sitekey: options?.site_key,
    Position: 'Left',
    Menulang: 'EN',
    domains: {
      js: 'https://cdn.equalweb.com/',
      acc: 'https://access.equalweb.com/',
    },
    btnStyle: {
      vPosition: ['100%', null],
      scale: ['0.6', '0.6'],
      color: { main: '#5c676e', second: '#ffffff' },
      icon: { type: 11, shape: 'circle', outline: false },
    },
  }

  if (window.interdeal) return

  if (
    options.alignHorizontal &&
    !['left', 'right'].includes(options.alignHorizontal)
  ) {
    console.warn('Invalid alignHorizontal specified.')
  }

  if (
    options.alignVertical &&
    !['bottom', 'middle'].includes(options.alignVertical)
  ) {
    console.warn('Invalid alignVertical specified.')
  }

  if (options.alignHorizontal === 'right') {
    defaultOptions.Position = 'Right'
  }

  if (options.alignVertical === 'middle') {
    defaultOptions.btnStyle.vPosition = ['50%', null]
  }

  window.interdeal = defaultOptions

  const coreCall = document.createElement('script')
  coreCall.src = window.interdeal.domains.js + 'core/5.0.13/accessibility.js'
  coreCall.defer = true
  coreCall.integrity =
    'sha512-pk3CeR0KGJu+GfK2x2ybTSZ1o1qfua6XW2PRAxMWOhC85M3+CanPYmvRp6BOiW0/riZjWGerRN7+JH4wEF0wJQ=='
  coreCall.crossOrigin = 'anonymous'
  coreCall.setAttribute('data-cfasync', true)
  document.body.appendChild(coreCall)
}

export const getAccessibilityScript = options =>
  `(${formattedBotnet.toString()}(${JSON.stringify(options)}))`
